import React from 'react'
import './BannerCard.scss'

interface BannerCardProps {
  title: string
  description?: string
  variant?: 'active' | 'expired' | 'warning' | 'info' | 'success'
  className?: string
  role?: string
  buttonText?: string
  onButtonClick?: () => void
  buttonLoading?: boolean
  buttonDisabled?: boolean
  showButton?: boolean
  showLink?: boolean
  linkText?: string
  onLinkClick?: () => void
}

const BannerCard: React.FC<BannerCardProps> = ({
  title,
  description,
  variant = 'active',
  className = '',
  role = 'alert',
  buttonText,
  onButtonClick,
  buttonLoading = false,
  buttonDisabled = false,
  showButton = false,
  showLink = false,
  linkText,
  onLinkClick
}) => {
  const getVariantClass = () => {
    const variants = {
      active: 'banner-active',
      expired: 'banner-expired',
      warning: 'banner-warning',
      info: 'banner-info',
      success: 'banner-success'
    }
    return variants[variant] || variants.active
  }

  return (
    <div
      className={`banner-card d-flex align-items-center ${getVariantClass()} ${className}`}
      role={role}
    >
      <div className='flex-grow-1'>
        <h6 className={`${description ? 'mb-1' : 'mb-0'}`}>
          {title}
          {showLink && linkText && (
            <>
              {' '}
              <span
                className='text-primary fw-bold cursor-pointer'
                onClick={onLinkClick}
              >
                {linkText}
              </span>
            </>
          )}
        </h6>
        {description && <p className='mb-0'>{description}</p>}
      </div>

      {showButton && (
        <div className='flex-shrink-0 ms-3 d-flex align-items-center'>
          <button
            className='btn btn-primary btn-md'
            onClick={onButtonClick}
            disabled={buttonDisabled || buttonLoading}
          >
            {buttonLoading ? (
              <span className='indicator-progress d-block'>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            ) : (
              buttonText
            )}
          </button>
        </div>
      )}
    </div>
  )
}

export default BannerCard
